var _defs, _g, _rect, _rect2, _rect3, _rect4, _rect5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEggCapacity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.26152 56.5991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .a {\r\n        fill: #808285;\r\n        stroke: #fff;\r\n        stroke-width: 1.14528px;\r\n      }\r\n\r\n      .a, .c, .d {\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .b, .c, .d {\r\n        fill: #fff;\r\n      }\r\n\r\n      .c, .d {\r\n        stroke: #808285;\r\n      }\r\n\r\n      .d {\r\n        stroke-width: 0.80454px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M48.90458,34.39833c0,16.12485-11.00277,21.675-20.77541,21.675S7.78834,50.52318,7.78834,34.39833,21.33581.4626,28.9191.62059,48.90458,18.27347,48.90458,34.39833Z",
    transform: "translate(-7.2157 -0.0469)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 34.51206,
    cy: 28.13946,
    rx: 4.55218,
    ry: 8.89744
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M15.70273,25.39905c-1.18548,3.59414-4.082,5.86936-6.46959,5.08185s-1.18694-3.31736-.00146-6.9115,1.90689-6.89154,4.29447-6.104S16.88821,21.80491,15.70273,25.39905Z",
    transform: "translate(-7.2157 -0.0469)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 18.527,
    cy: 12.22898,
    r: 2.27609
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 15.42231,
    cy: 50.12614,
    rx: 5.66977,
    ry: 4.15224
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "b",
    cx: 18.86816,
    cy: 32.3321,
    rx: 5.13772,
    ry: 5.5865
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M31.79057,1.47383c0,3.08534,2.53688,6.47216,5.37436,6.47216s-.02548-.28447-.02548-3.36981Z",
    transform: "translate(-7.2157 -0.0469)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 3.19254,
    y: 50.72102,
    width: 35.1302,
    height: 2.13408,
    rx: 1.06704
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 1.23766,
    y: 48.09446,
    width: 35.1302,
    height: 2.13408,
    rx: 1.06704
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 9.42327,
    y: 49.61881,
    width: 35.1302,
    height: 2.13408,
    rx: 1.06704,
    transform: "matrix(0.97858, 0.20587, -0.20587, 0.97858, 3.79691, -4.51722)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 9.75893,
    y: 52.8551,
    width: 22.73906,
    height: 2.13408,
    rx: 1.06704
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "c",
    x: 12.54231,
    y: 49.78297,
    width: 35.1302,
    height: 2.13408,
    rx: 1.06704,
    transform: "translate(-16.64859 6.88564) rotate(-11.36869)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEggCapacity);
export default __webpack_public_path__ + "static/media/EggCapacity.ad4c4c4d5193c67aa9e5585edd1b1e6a.svg";
export { ForwardRef as ReactComponent };